// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class EncryptionKeyTMO {
	public id: string = undefined;

	public keyIdentifier?: string = undefined;

	public algorithm: KeyAlgorithmEnum = undefined;

	public scope?: KeyScopeEnum = undefined;

	public parentOrgId?: string = undefined;

	public status: EncryptionKeyStatusEnum = undefined;

	public publicKey: string = undefined;

	public privateKeyReference?: string = undefined;

	public createdDate: Date = undefined;

	public lastModifiedDate?: Date = undefined;
}

export class EncryptionKeyBodyTMO {
	keyId: string = undefined;

	algorithm?: KeyAlgorithmEnum = undefined;

	storePrivateKey?: boolean = undefined;
}

export class EncryptionKeyExportTMO {
	keyInfo?: EncryptionKey = new EncryptionKey();

	privateKey?: string = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class EncryptionKey extends EncryptionKeyTMO {

	public privateKey?: string = undefined;

	public etag?: string = undefined;
}

export class EncryptionKeyExport extends EncryptionKeyExportTMO {}

// INTERFACES ########################################################
// API interfaces ****************************************************
// Encryption Key Status
export interface EncryptionKeyStatus {
	status?: EncryptionKeyStatusEnum;
}

// Encryption Key Export Response
export interface EncryptionKeyExportResponse {
	keyInfo?: EncryptionKey;

	privateKey?: string;
}

// Encryption Key Body
export interface EncryptionKeyBody {
	keyId: string;

	algorithm?: KeyAlgorithmEnum;

	storePrivateKey?: boolean;
}

// UI interfaces *****************************************************

// ENUMS #############################################################
// API enums *********************************************************

// STATUS
export enum EncryptionKeyStatusEnum {
	Active = 'active',
	Disabled = 'disabled',
	Deleted = 'deleted'
}

// KEY SCOPE
export enum KeyScopeEnum {
	Tenant = 'tenant',
	Organization = 'organization'
}

// KEY ALGORITHM
export enum KeyAlgorithmEnum {
	RSA_3072 = 'RSA-3072',
	RSA_4096 = 'RSA-4096'
}

// UI enums *********************************************************
